import React from "react"
import {
    CSpinner,
    CButton
} from '@coreui/react'
import CIcon from '@coreui/icons-react'

export default class AppButton extends React.Component {

    render() {
        
        var color = this.props.color ? this.props.color : "dark";
        if (this.props.disabled) {
            color = "secondary";
        }

        var classes = "boldFont";
        if (this.props.className && this.props.className.length > 0) {
            classes += " " + this.props.className;
        }

        return (
            <CButton
                color={color}
                size={this.props.size ? this.props.size : "sm"}
                className={classes} 
                onClick={() => this.props.onClick ? this.props.onClick() : null}
                style={this.props.style}
                disabled={this.props.disabled}>
                {
                    this.props.isLoading ?
                        <CSpinner color="light" size="sm" component="span" className="btnSpinner" />
                        :
                        this.props.icon ?
                            <CIcon icon={this.props.icon} />
                            : null
                }
                {this.props.name}
            </CButton>
        );
    }
}